import axios from "axios";
import { LOCALSTORAGE_TOKEN } from "../../config";

export async function getUsers() {
  let token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  let config = { headers: { Authorization: `bearer ${token}` } };

  const data = await axios.get(
    `${process.env.API_BASE_URL}/api/users/`,
    config
  );
  return data.data;
}

export async function setManagerRole(user, isManager) {
  let token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  let config = { headers: { Authorization: `bearer ${token}` } };

  let payload = { user: { is_manager: isManager } };
  payload.is_manager = isManager;
  const data = await axios.put(
    `${process.env.API_BASE_URL}/api/users/${user.id}`,
    payload,
    config
  );
  return data.data;
}



// WEBPACK FOOTER //
// ./src/modules/manager/services.js